var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAnnounce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    clipPath: "url(#icon_announce_svg__clip0)",
    stroke: "#FF6459",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.313 29.28l9.548 9.55a.5.5 0 00.754-.055L45.12 10.043a.5.5 0 00-.504-.79L3.152 18.028a.5.5 0 00-.25.843l8.198 8.198",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.289 9.92L13.313 29.28M44.289 9.92L11.1 27.069",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 27.068l.696 11.616 1.517-9.403",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.796 38.684l4.062-3.595 1.015-.9.508-.449"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_announce_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90 24 24)",
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC45IiBjbGlwLXBhdGg9InVybCgjY2xpcDApIj4KPHBhdGggZD0iTTEzLjMxMjkgMjkuMjgwN0wyMi44NjE0IDM4LjgyOTJDMjMuMDc2NyAzOS4wNDQ1IDIzLjQzMjggMzkuMDE5MSAyMy42MTUyIDM4Ljc3NTNMNDUuMTIwMiAxMC4wNDI2QzQ1LjM5NjcgOS42NzMyMSA0NS4wNjc5IDkuMTU4MzQgNDQuNjE2NCA5LjI1Mzg2TDMuMTUxOTkgMTguMDI3QzIuNzYzNzUgMTguMTA5MiAyLjYyMTM0IDE4LjU4OTEgMi45MDE5NCAxOC44Njk4TDExLjEwMDMgMjcuMDY4MSIgc3Ryb2tlPSIjRkY2NDU5IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNDQuMjg4NiA5LjkyMDlMMTMuMzEyNiAyOS4yODA4IiBzdHJva2U9IiNGRjY0NTkiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik00NC4yODg2IDkuOTIwOUwxMS4xMDAxIDI3LjA2ODMiIHN0cm9rZT0iI0ZGNjQ1OSIgc3Ryb2tlLXdpZHRoPSIxLjI1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTExLjEwMDEgMjcuMDY4NEwxMS43OTU4IDM4LjY4NDRMMTMuMzEyNyAyOS4yODA5IiBzdHJva2U9IiNGRjY0NTkiIHN0cm9rZS13aWR0aD0iMS4yNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMS43OTU5IDM4LjY4NEwxNS44NTc1IDM1LjA4ODVMMTYuODcyOSAzNC4xODk3TDE3LjM4MDYgMzMuNzQwMiIgc3Ryb2tlPSIjRkY2NDU5IiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNDgpIHJvdGF0ZSgtOTApIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgIconAnnounce as ReactComponent };